import "./AboutMe.css";
import ZaneImage from "../../images/Zane2.jpeg";
import ZaneCroppedImage from "../../images/Zane-cropped.jpeg";
import { useEffect, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "../CustomAccordion.js";
import { useLocation, Link } from "react-router-dom";
import HighlightBlock from "../HighlightBlock.js";

function AboutMe() {
    const programmingLanguages = [
        "Python",
        "C#",
        "Javascript/TypeScript",
        "SQL",
        "HTML",
        "CSS",
        "Powershell",
        "Java",
    ];
    const libraries = [
        "Git",
        "React",
        ".NET",
        "Flask",
        "Pandas",
        "NumPy",
        "PyTorch",
        "Claude API / Anthropic SDK",
        "Apple Vision (OCR)",
        "Material UI",
        "MySQL",
        "Postman",
        "AWS CDK",
        "AWS SDK",
    ];
    const aws = [
        "Lambda",
        "S3",
        "DynamoDB",
        "Amplify",
        "API Gateway",
        "CloudFront",
        "CloudFormation",
        "Route 53",
        "IAM",
        "ACM",
        "RDS",
        "Bedrock",
    ];
    const concepts = [
        "System Design",
        "Cloud Architecture (AWS)",
        "Distributed Systems",
        "Full-Stack Development",
        "LLM Application Development",
        "REST APIs",
        "Infrastructure as Code",
        "CI/CD",
        "Message Brokers",
        "Relational Databases",
        "Object-Oriented Programming",
        "Unit + Component Testing",
        "Integration + Performance Testing",
        "Agile Development / Scrum",
        "Data Structures & Algorithms",
    ];

    let yearsSince2017 = new Date().getFullYear() - 2017;
    let yearsSince2024 = new Date().getFullYear() - 2024;

    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [expanded4, setExpanded4] = useState(false);
    const [expanded5, setExpanded5] = useState(false);

    const location = useLocation();
    let scrollTo = null;

    if (location.state) {
        scrollTo = location.state.scrollTo || null;
    } else if (location.hash) {
        scrollTo = location.hash.replace("#", "");
    }

    let image = ZaneImage;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        document.title = "About Me | Zane Bookbinder";

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    if (windowWidth < 800) {
        image = ZaneCroppedImage;
    }

    useEffect(() => {
        if (scrollTo) {
            const targetElement = document.getElementById(scrollTo);
            const offset = 80;
            const targetPosition = targetElement.offsetTop - offset;

            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        }
    }, [scrollTo]);

    return (
        <div className="about-me">
            <h1 className="title desktop-title">About Me</h1>
            <div className="bio-and-image">
                <div className="bio">
                    <h1 className="title mobile-title">About Me</h1>
                    <p className="small-text about-me-text">
                        Hi! I'm proud to be a JOB (Just Outside of Boston) from
                        Newton, MA and a recent grad of Bowdoin College. Now, I
                        work in the Trading Technology org at Bridgewater
                        Associates. My team is responsible for implementing the 
                        asset-class-agnostic trading logic 
                        that allows Bridgewater to systematically trade
                        billions of dollars monthly across thousands of markets,
                        while limiting trading costs and risk.
                    </p>
                    <p className="small-text about-me-text">
                        At Bowdoin, I worked as a Teaching Assistant, interviewed
                        applicants with the Admissions team, and built some cool
                        websites.
                    </p>
                    <p className="small-text about-me-text">
                        I'm super passionate about software! In the{" "}
                        {yearsSince2017} years since I took my first Computer
                        Science class, I've completed:
                    </p>
                    <div className="accordions">
                        <Accordion
                            disableGutters
                            elevation={0}
                            expanded={expanded1}
                            onChange={() => setExpanded1(!expanded1)}
                            className={expanded1 ? "accordion-expanded" : ""}
                        >
                            <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                            >
                                {yearsSince2024} {yearsSince2024 > 1 ? "years" : "year"} of full-time SWE work
                            </AccordionSummary>
                            <AccordionDetails>
                                <ul className="list-with-background">
                                    <li>
                                        <Link
                                            to="/experience#bridgewater"
                                        >
                                            Software Engineer at Bridgewater Associates
                                            (2024-)
                                        </Link>
                                    </li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            disableGutters
                            elevation={0}
                            expanded={expanded5}
                            onChange={() => setExpanded5(!expanded5)}
                            className={expanded5 ? "accordion-expanded" : ""}
                        >
                            <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                            >
                                4 internships
                            </AccordionSummary>
                            <AccordionDetails>
                                <ul className="list-with-background">
                                    <li>
                                        <Link
                                            to="/experience#amazon"
                                        >
                                            Software Engineer Intern at Amazon
                                            (Summer 2023)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#datto"
                                        >
                                            Data Engineer Intern at Datto
                                            (Summer 2022)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#beamlab"
                                        >
                                            Machine Learning and AI Intern at
                                            Beamlab (Summer 2021)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#brain-power"
                                        >
                                            Software Engineer Intern at
                                            Brainpower (Summer 2019)
                                        </Link>{" "}
                                    </li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            disableGutters
                            elevation={0}
                            expanded={expanded3}
                            onChange={() => setExpanded3(!expanded3)}
                            className={expanded3 ? "accordion-expanded" : ""}
                        >
                            <AccordionSummary
                                aria-controls="panel3d-content"
                                id="panel3d-header"
                            >
                                30+ projects
                            </AccordionSummary>
                            <AccordionDetails>
                                <p className="section-title">
                                    Here are some of my favorites:
                                </p>
                                <ul className="list-with-background">
                                    <li>
                                        <Link
                                            to="/experience#bcr"
                                        >
                                            Bowdoin Course Reviews
                                            (React/Flask/MySQL, 2022-2023)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#ungated"
                                        >
                                            Ungated Research (React/Flask/MySQL,
                                            2024)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#fml-final-project"
                                        >
                                            Beating the Bookies (Python, 2024)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#drive-thru"
                                        >
                                            Drive Thru
                                            (React/Node/TypeScript, 2026)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#games-plan-2028"
                                        >
                                            Games Plan 2028
                                            (JavaScript/Python/AWS, 2026)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#shelf-aware"
                                        >
                                            ShelfAware (Swift/SwiftUI/AWS, 2026)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#bethpage-black-bot"
                                        >
                                            Bethpage Black Bot
                                            (Python/React/AWS, 2025)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/experience#GPS"
                                        >
                                            Global PassStore (Python/Bash, 2022)
                                        </Link>
                                    </li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            disableGutters
                            elevation={0}
                            expanded={expanded2}
                            onChange={() => setExpanded2(!expanded2)}
                            className={expanded2 ? "accordion-expanded" : ""}
                        >
                            <AccordionSummary
                                aria-controls="panel2d-content"
                                id="panel2d-header"
                            >
                                12 Computer Science classes
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="multiple-lists">
                                    <div className="list-section">
                                        <p className="section-title">
                                            Bowdoin College (Brunswick, Maine)
                                        </p>
                                        <ul className="list-with-background">
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~sbarker/teaching/courses/ds/21fall/"
                                                >
                                                    CSCI 2101: Data Structures
                                                    (Java, 2020)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~ltoma/teaching/cs231/fall13/"
                                                >
                                                    CSCI 2200: Algorithms
                                                    (Python, 2021)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~smajerci/teaching/cs2210/2019spring/index.html"
                                                >
                                                    CSCI 2210: Theory of
                                                    Computation (2022)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~mirfan/CSCI-2320.html"
                                                >
                                                    CSCI 2320: Principles of
                                                    Programming Languages
                                                    (Python, 2022)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~sbarker/teaching/courses/systems/22fall/"
                                                >
                                                    CSCI 2330: Foundations of
                                                    Computer Systems (C, 2021)
                                                </a>
                                            </li>
                                            <li className="no-link">
                                                CSCI 2400: Artificial
                                                Intelligence (Python, 2022)
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://tildesites.bowdoin.edu/~sbarker/teaching/courses/distributed/22spring/"
                                                >
                                                    CSCI 3325: Distributed
                                                    Systems (C/Java/Python,
                                                    2022)
                                                </a>
                                            </li>
                                            <li className="no-link">
                                                CSCI 3725: Computational
                                                Creativity
                                                (Python/Ruby/JS/Processing,
                                                2023)
                                            </li>
                                            <li className="no-link">
                                                CSCI 3465: Financial Machine
                                                Learning (Python, 2024)
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="list-section">
                                        <p className="section-title">
                                            Milton Academy (Milton, MA)
                                        </p>
                                        <ul className="list-with-background">
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://www.milton.edu/academics/academic-departments/computer-science-courses/"
                                                >
                                                    Computer Programming 1
                                                    (Java, 2017-2018)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://www.milton.edu/academics/academic-departments/computer-science-courses/"
                                                >
                                                    Computer Programming 2
                                                    (Java, 2018-2019)
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href="https://www.milton.edu/academics/academic-departments/computer-science-courses/"
                                                >
                                                    Advanced Computer
                                                    Programming: Applied Math &
                                                    AI (Python, 2019-2020)
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            disableGutters
                            elevation={0}
                            expanded={expanded4}
                            onChange={() => setExpanded4(!expanded4)}
                            className={expanded4 ? "accordion-expanded" : ""}
                        >
                            <AccordionSummary
                                aria-controls="panel3d-content"
                                id="panel3d-header"
                            >
                                3 Semesters as Learning Assistant and Grader
                            </AccordionSummary>
                            <AccordionDetails>
                                <ul className="list-with-background">
                                    <li>
                                        Fall 2021: Algorithms Learning Assistant
                                        and Grader
                                    </li>
                                    <li>
                                        Spring 2022: Algorithms Learning
                                        Assistant and Grader
                                    </li>
                                    <li>
                                        Fall 2022: Foundations of Computer
                                        Systems Learning Assistant
                                    </li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
                <img className="zane-second-image" alt="Zane" src={image} />
            </div>
            <div className="bottom-columns">
                <div className="column">
                    <div className="section">
                        <h1>Education</h1>
                        <ul>
                            <li>
                                <p className="bottom-text">
                                    <span>
                                        <a
                                            href="https://www.bowdoin.edu/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Bowdoin College:
                                        </a>
                                    </span>
                                    Computer Science major, Economics minor
                                    (2020-2024)
                                </p>
                            </li>
                            <li>
                                <p className="bottom-text">
                                    <span>
                                        <a
                                            href="https://www.milton.edu/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Milton Academy:
                                        </a>
                                    </span>
                                    (2016-2020)
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="section">
                        <h1>Awards</h1>
                        <ul>
                            <li>
                                <p>
                                    <span>
                                        <a
                                            href="https://www.bowdoin.edu/registrar/students/completing-degree/latin-honors-recipients.html"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Graduated Cum Laude
                                        </a>
                                    </span>
                                    from Bowdoin College (2024)
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>
                                        <a
                                            href="https://www.bowdoin.edu/about/prizes/general-scholarship.html"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Dorothy Haythorn Collins Award
                                        </a>
                                    </span>
                                    for academic and general excellence in
                                    Computer Science (2022-2023)
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>
                                        <a
                                            href="https://www.bowdoin.edu/admissions/book-award/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Bowdoin Book Award
                                        </a>
                                    </span>
                                    for a 4.0 GPA (2021-2022)
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>
                                        <a
                                            href="https://www.bowdoin.edu/events/family-weekend/sarah-and-james-bowdoin-day.html"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Sarah and James Bowdoin Scholar
                                        </a>
                                    </span>
                                    — Dean's List (2021-2022)
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>
                                        <a
                                            href="https://www.milton.edu/news/graduation-2020/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Graduated Cum Laude
                                        </a>
                                    </span>
                                    from Milton Academy (2020)
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="section">
                        <h1>Languages</h1>
                        <ul>
                            <li>
                                <span>Proficient Spanish</span>
                            </li>
                            <ul>
                                <li>11 years of Spanish classes</li>
                                <li>
                                    Lived in Madrid with a Spanish family (June
                                    2018)
                                </li>
                                <li>Studied abroad in Madrid (Spring 2023)</li>
                            </ul>
                        </ul>
                    </div>
                </div>
                <div className="column">
                    <div className="section">
                        <h1 id="skills">Technical Skills</h1>
                        <ul>
                            <li>
                                <span>Programming Languages</span>
                                <div className="skill-list">
                                    {programmingLanguages.map(
                                        (language, index) => {
                                            return (
                                                <HighlightBlock
                                                    key={index}
                                                    text={language}
                                                />
                                            );
                                        }
                                    )}
                                </div>
                            </li>
                            <li>
                                <span>Libraries, Frameworks, and Tools</span>
                                <div className="skill-list">
                                    {libraries.map((library, index) => {
                                        return (
                                            <HighlightBlock
                                                key={index}
                                                text={library}
                                            />
                                        );
                                    })}
                                </div>
                            </li>
                            <li>
                                <span>AWS Services</span>
                                <div className="skill-list">
                                    {aws.map((service, index) => {
                                        return (
                                            <HighlightBlock
                                                key={index}
                                                text={service}
                                            />
                                        );
                                    })}
                                </div>
                            </li>
                            <li>
                                <span>Concepts</span>
                                <div className="skill-list">
                                    {concepts.map((concept, index) => {
                                        return (
                                            <HighlightBlock
                                                key={index}
                                                text={concept}
                                            />
                                        );
                                    })}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="section">
                        <h1 id="interests">Interests</h1>
                        <ul>
                            <li>
                                <p>
                                    AI/ML, Professional sports (particularly
                                    Boston teams), Golf, Skiing, Reading (mostly
                                    non-fiction)
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutMe;
